// src/components/UpcomingGames/UpcomingGames.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UpcomingGames.css';
import GameCard from '../GameCard/GameCard'; // Import the GameCard component
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { clearStoredAdminSession, runAdminAuthedRequest } from '../../utils/adminAuth';

const STATUS_LABELS = {
  upcoming: 'Upcoming',
  'in progress': 'In Progress',
  finished: 'Needs Settlement',
  settled: 'Settled',
};

const toDateTime = (game) => {
  try {
    const datePart = new Date(game.date).toISOString().split('T')[0];
    const dt = new Date(`${datePart}T${game.time}`);
    if (Number.isNaN(dt.getTime())) return new Date(game.date);
    return dt;
  } catch (_) {
    return new Date(game.date);
  }
};

const UpcomingGames = () => {
  const [gamesByDate, setGamesByDate] = useState({});
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Initialize navigate

  const handleAuthFailure = () => {
    clearStoredAdminSession();
    window.location.assign('/login');
  };

  useEffect(() => {
    const fetchUpcomingGames = async () => {
      try {
        const response = await runAdminAuthedRequest(
          (idToken) =>
            axios.get(`${process.env.REACT_APP_API_URL}/games/managed`, {
              headers: {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json',
              },
            }),
          {
            onAuthFailure: handleAuthFailure,
          }
        );
        if (!response) return;
        const games = Array.isArray(response.data) ? response.data : [];

        const openGames = games
          .filter((game) => game?.status !== 'settled')
          .sort((a, b) => toDateTime(b) - toDateTime(a));

        // Group games by date
        const groupedGames = openGames.reduce((acc, game) => {
          const date = new Date(game.date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: '2-digit',
            month: '2-digit',
          });

          if (!acc[date]) acc[date] = [];
          acc[date].push(game);
          return acc;
        }, {});

        setGamesByDate(groupedGames);
      } catch (error) {
        console.error('Error fetching open games:', error);
        setError('Failed to fetch games.');
      }
    };

    fetchUpcomingGames();
  }, []);

  return (
    <div className="upcoming-games-container">
      {error && <p className="error-message">{error}</p>}
      {Object.keys(gamesByDate).map((date) => (
        <div key={date} className="day-section">
          <h3 className="date-header">{date}</h3>
          <div className="games-row">
            {gamesByDate[date].map((game) => (
              <div
                key={game._id}
                className="game-card-wrapper"
                onClick={() => navigate(`/manage-game/${game._id}`)}
              >
                <GameCard
                  imageSrc={game.stadium?.stadiumPicturePath || game.stadium?.stadiumPicture}
                  name={game.stadium?.name}
                  subtitle={`${game.type} • ${STATUS_LABELS[game.status] || game.status || 'Open'}`}
                  dayOrDate={game.date}
                  timeOrCapacity={game.time}
                  id={game._id}
                  isGame={true}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UpcomingGames;
